import { css } from 'styled-components';
import token from 'styled-token';

/** @class AccordionItemMixin */
/** @method */
export var AccordionItemMixin = function AccordionItemMixin(props) {
  return token({
    borderColor: 'AccordionItem.borderColor',
    borderRadius: 'AccordionItem.borderRadius',
    borderWidth: 'AccordionItem.borderWidth',
    spacing: 'AccordionItem.spacing'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth,
      spacing = _ref.spacing;
    return css(["border:", "px solid ", ";border-radius:", "px;&:not(:last-child){margin-bottom:", "px;}"], borderWidth, borderColor, borderRadius, spacing);
  })(props);
};